"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayOpacityScheduleDto = exports.OpacityDaySchedule = exports.OpacityTimeRange = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
class OpacityTimeRange {
    from;
    to;
    opacity = 0; // Opacity value from 0 (transparent) to 100 (opaque)
}
exports.OpacityTimeRange = OpacityTimeRange;
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Transform)(({ value }) => Number(value)),
    __metadata("design:type", Number)
], OpacityTimeRange.prototype, "from", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Transform)(({ value }) => Number(value)),
    __metadata("design:type", Number)
], OpacityTimeRange.prototype, "to", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Transform)(({ value }) => Number(value || 0)),
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.Max)(100),
    __metadata("design:type", Number)
], OpacityTimeRange.prototype, "opacity", void 0);
class OpacityDaySchedule {
    isOperative;
    timetable;
}
exports.OpacityDaySchedule = OpacityDaySchedule;
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(({ value }) => value === "true" || value === true),
    __metadata("design:type", Boolean)
], OpacityDaySchedule.prototype, "isOperative", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => OpacityTimeRange),
    (0, class_validator_1.ValidateIf)((o) => o.isOperative),
    __metadata("design:type", Array)
], OpacityDaySchedule.prototype, "timetable", void 0);
class DisplayOpacityScheduleDto {
    mon;
    tue;
    wed;
    thu;
    fri;
    sat;
    sun;
}
exports.DisplayOpacityScheduleDto = DisplayOpacityScheduleDto;
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => OpacityDaySchedule),
    __metadata("design:type", OpacityDaySchedule)
], DisplayOpacityScheduleDto.prototype, "mon", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => OpacityDaySchedule),
    __metadata("design:type", OpacityDaySchedule)
], DisplayOpacityScheduleDto.prototype, "tue", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => OpacityDaySchedule),
    __metadata("design:type", OpacityDaySchedule)
], DisplayOpacityScheduleDto.prototype, "wed", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => OpacityDaySchedule),
    __metadata("design:type", OpacityDaySchedule)
], DisplayOpacityScheduleDto.prototype, "thu", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => OpacityDaySchedule),
    __metadata("design:type", OpacityDaySchedule)
], DisplayOpacityScheduleDto.prototype, "fri", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => OpacityDaySchedule),
    __metadata("design:type", OpacityDaySchedule)
], DisplayOpacityScheduleDto.prototype, "sat", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => OpacityDaySchedule),
    __metadata("design:type", OpacityDaySchedule)
], DisplayOpacityScheduleDto.prototype, "sun", void 0);
